// src/components/scan/Footer/FooterMobile.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import logo from '../../../assets/damelio_logo_blanco.png';
import logoText from '../../../assets/damelio_texto_blanco.png';

export default function FooterMobile() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-400 py-8 px-4 w-full relative z-20">
      <div className="max-w-md mx-auto">
        {/* Grid responsive */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-8 text-center text-sm mb-8">
          {/* Recursos */}
          <div>
            <h4 className="text-white font-semibold mb-2">{t('footer.resourcesTitle')}</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/dashboard" className="hover:text-white transition">
                  {t('footer.dashboard')}
                </Link>
              </li>
              <li>
                <Link to="/documentation" className="hover:text-white transition">
                  {t('footer.documentation')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition">
                  {t('footer.faq')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Colaboraciones */}
          <div>
            <h4 className="text-white font-semibold mb-2">{t('footer.partnersTitle')}</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/partners" className="hover:text-white transition">
                  {t('footer.partnersLink')}
                </Link>
              </li>
              <li>
                <a href="mailto:partners@damelio.io" className="hover:text-white transition">
                  partners@damelio.io
                </a>
              </li>
            </ul>
          </div>

          {/* Información Legal: en sm ocupa dos columnas, en lg solo una */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-white font-semibold mb-2">{t('footer.infoTitle')}</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/privacy-policy" className="hover:text-white transition">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/cookies-policy" className="hover:text-white transition">
                  {t('footer.cookies')}
                </Link>
              </li>
              <li>
                <Link to="/legal-notice" className="hover:text-white transition">
                  {t('footer.legal')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Logo centrado */}
        <div className="flex justify-center mb-4">
          <Link to="/" className="inline-flex items-center space-x-2">
            <img src={logo} alt="Damelio Logo" className="h-12 w-12 object-contain" />
            <img src={logoText} alt="Damelio Texto" className="h-6 object-contain" />
          </Link>
        </div>

        {/* Derechos */}
        <div className="text-center text-xs text-gray-500">
          © 2026 <span className="text-white font-semibold">Damelio</span>. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
}
